<template>
  <div class="filters">
    <div class="container">
      <!-- <div class="row">
        <div 
          :class="getClass()" 
          @click="show = !show" 
          @click.stop="stopPropagation"
        >
          <img
            class="title-down"
            v-if="show && role === 'superadmin'"
            src="../../images/dashboard/down-blue.png"
            alt="#"
          />
          <img
            class="title-down"
            v-else
            src="../../images/dashboard/down-white.png"
            alt="#"
          />
          <span class="drop-down-menu">{{ title[step] }}</span>
        </div>
        <transition>
          <ManagementList
            v-click-outside="closeModelList"
            @title="setTitle"
            v-if="show && role === 'superadmin'"
            @showoutlinerfilters="showoutlinerfilters"
          ></ManagementList>
        </transition>
        <div>
          <div class="input-wrap title_radio" v-if="step === 0 || step === 4">
                  <label name="pay_types" class="pay_types" :style="{ color: payment_type == 'paid'? '#005eb8' : '#b3b3b3' }"  v-on:click="payment_type_change('paid')">Paid </label>
                  <label  name="pay_types" class="pay_types" :style="{ color: payment_type == 'free' ? '#005eb8' : '#b3b3b3' }" v-on:click="payment_type_change('free')">Promo </label>
                  <label name="pay_types" class="pay_types" :style="{ color: payment_type === 'both' ? '#005eb8' : '#b3b3b3' }" v-on:click="payment_type_change('both')">All</label>
          </div>
        </div
      </div> -->
      <div class="justify-content-center" v-if="(step == 5 || step == 3  || step == 9)" >
        <span  class="menu-label">{{ menu_label }}</span>
      </div>
      <div class="anaytic-heading" v-if="step == 3">
          
          <p
            class="visible-mold-header fix-header"
            v-if="analytics_header.type === 'visible_mold'"
          >
            Is there visible mold? {{ analytics_header.sub_type }} :
            {{ analytics_header.count }}/{{ analytics_header.total }}
          </p>
          <p
            class="musty-damp-odor-header fix-header"
            v-if="analytics_header.type === 'musty_damp_odor'"
          >
            Is there a "musty" or "damp" odor?
            {{ analytics_header.sub_type }} :
            {{ analytics_header.count }}/{{ analytics_header.total }}
          </p>
          <p
            class="symptoms-header fix-header"
            v-if="analytics_header.type === 'symptoms'"
          >
            Is anyone experiencing symptoms that you think might be
            mold-related? {{ analytics_header.sub_type }} :
            {{ analytics_header.count }}/{{ analytics_header.total }}
          </p>
      </div>
      
      <div class="row" :class="step == 3? 'filter-research-all' : 'filter-all'">
        <div :style="{width:'100%' }">
          <Search
            v-if="(step == 0 || step == 4  || step == 1 || step == 2 || step == 10)"
            :steps="step"
          />
        </div>
        <!-- <div class="justify-content-center-search" v-if="(step == 0 || step == 4  || step == 1 || step == 2 || step == 10 || step == 11)" :style="{width:'100%' }" >
          <span  class="menu-label">{{ menu_label }}</span>
        </div> -->
        <transition name="router-anim">
          <div class="filter-items" v-if="step == 32" >
            <div class="datepickerWrapDiv">
                <Datepicker
                  placeholder="Date From"
                  v-model="date_from"
                  :format="formatDate"
                  :disabledDates="disabledDatesFrom"
                  :calendar-class="{ calendarWrap: true }"
                  :class="{ datepickerWrapAdmin: true }"
                  :input-class="{ datepickerInputAdmin: true }"
                ></Datepicker>
                <img
                  src="../../images/dashboard/calendar.png"
                  alt="#"
                  class="datepickerWrapDiv-img"
                />
                <button
                  class="datepickerWrapDiv-img-cross"
                  v-if="date_from !== null"
                  @click="date_from = null"
                >
                  <CloseIcone></CloseIcone>
                </button>
              </div>
              <div class="datepickerWrapDiv">
                <Datepicker
                  placeholder="Date To"
                  v-model="date_to"
                  :format="formatDate"
                  :disabledDates="disabledDatesTo"
                  :calendar-class="{ calendarWrap: true }"
                  :class="{ datepickerWrapAdmin: true }"
                  :input-class="{ datepickerInputAdmin: true }"
                ></Datepicker>
                <img
                  src="../../images/dashboard/calendar.png"
                  alt="#"
                  class="datepickerWrapDiv-img"
                />
                <button
                  class="datepickerWrapDiv-img-cross"
                  v-if="date_to !== null"
                  @click="date_to = null"
                >
                  <CloseIcone></CloseIcone>
                </button>
              </div>
          </div>
        </transition>
          <div v-if="step === 8">
            <div class="filter-items-customer" v-if="customerkit == 0">
              <SearchCustomer/>
                <span
                  class="download-link"
                  target="_blank"
                  @click="customersCsv"
                >
                <span class="download">
                  <img src="../../images/dashboard/download.svg" alt="#" />
                </span>
              </span>
            <div class="filter-wrap-custom">
              <select
                v-model="filterSelect"
                class="input-filter"
                @change="handleChange"
              >
                <option value="0">All</option>
                <option value="2">> 2</option>
                <option value="3">> 3</option>
                <option value="4">> 4</option>
                <option value="5">5 to 10</option>
                <option value="10">> 10</option>
              </select>
            </div>
          </div>
          <span v-else>
            <button class="btn btn-test custom" @click="showCustomer">
              Back
            </button>
          </span>
        </div>
        <transition name="router-anim">
          <div v-if="step === 0 || step === 4">
            <div class="filter-items">
              <span
                v-if="step === 0"
                class="download-link"
                title="Download this list as CSV"
                target="_blank"
                @click="testKitsCsv"
              >
                <span class="download">
                  <img src="../../images/dashboard/download.svg" alt="#" />
                </span>
              </span>
              <div
                class="filter-wrap"
                v-click-outside="closeModel"
                v-if="step === 0"
              >
                <button
                  class="btn btn-filter"
                  :class="{ open: showFilters }"
                  @click="showFilters = !showFilters"
                >
                  Filter
                </button>
                <ul class="filter-list-wrap" v-show="showFilters">
                  <li class="filter-list-item hide">Status</li>
                  <li
                    class="filter-list-item"
                    @click="setFilter(0, 'shipped',1)"
                    :class="{ active: shipped }"
                  >
                    Shipped
                  </li>
                  <li
                    class="filter-list-item"
                    @click="setFilter(7, 'delivered', 1)"
                    :class="{ active: delivered }"
                  >
                    Delivered
                  </li>
                  <li
                    class="filter-list-item"
                    @click="setFilter(1, 'activated', 1)"
                    :class="{ active: activated }"
                  >
                    Activated
                  </li>
                  <li
                    class="filter-list-item"
                    @click="setFilter(2, 'awaiting', 1)"
                    :class="{ active: awaiting }"
                  >
                    Submitted
                  </li>
                  <li
                    class="filter-list-item"
                    @click="setFilter(3, 'received', 1)"
                    :class="{ active: received }"
                  >
                    Lab Received
                  </li>
                  <li
                    class="filter-list-item"
                    @click="setFilter(4, 'hold', 1)"
                    :class="{ active: hold }"
                  >
                    On Hold
                  </li>
                  <li
                    class="filter-list-item"
                    @click="setFilter(5, 'complete', 1)"
                    :class="{ active: complete }"
                  >
                    Analysis Complete
                  </li>
                  <li
                    class="filter-list-item"
                    @click="setFilter(6, 'problem', 1)"
                    :class="{ active: problem }"
                  >
                    Problematic Kits
                  </li>
                  <li
                    class="filter-list-item"
                    @click="setFilter(8, 'archive', 1)"
                    :class="{ active: archive }"
                  >
                     Archived Kits
                  </li>
                </ul>
              </div>
              <span
                class="download-link"
                title="Download"
                target="_blank"
                @click="outlierkitCsvDownload"
                v-if="step === 4"
              >
                <span class="download">
                  <img src="../../images/dashboard/download.svg" alt="#" />
                </span>
              </span>
              <div class="datepickerWrapDiv">
                <Datepicker
                  placeholder="Date From"
                  v-model="date_from"
                  :format="formatDate"
                  :disabledDates="disabledDatesFrom"
                  :calendar-class="{ calendarWrap: true }"
                  :class="{ datepickerWrapAdmin: true }"
                  :input-class="{ datepickerInputAdmin: true }"
                ></Datepicker>
                <img
                  src="../../images/dashboard/calendar.png"
                  alt="#"
                  class="datepickerWrapDiv-img"
                />
                <button
                  class="datepickerWrapDiv-img-cross"
                  v-if="date_from !== null"
                  @click="date_from = null"
                >
                  <CloseIcone></CloseIcone>
                </button>
              </div>
              <div class="datepickerWrapDiv">
                <Datepicker
                  placeholder="Date To"
                  v-model="date_to"
                  :format="formatDate"
                  :disabledDates="disabledDatesTo"
                  :calendar-class="{ calendarWrap: true }"
                  :class="{ datepickerWrapAdmin: true }"
                  :input-class="{ datepickerInputAdmin: true }"
                ></Datepicker>
                <img
                  src="../../images/dashboard/calendar.png"
                  alt="#"
                  class="datepickerWrapDiv-img"
                />
                <button
                  class="datepickerWrapDiv-img-cross"
                  v-if="date_to !== null"
                  @click="date_to = null"
                >
                  <CloseIcone></CloseIcone>
                </button>
              </div>
              <button
                v-if="role === 'superadmin' && step === 0"
                class="btn btn-test"
                @click="addTestKitModal"
                @click.stop="stopPropagation"
              >
                Add Test Kit
              </button>
            </div>
            <div class="btn-filter-item-wrap-5" v-if="step === 0 ">
              <button class="btn btn-filter-item" v-for="item in filters">
                <img
                  @click="resetStatusFilter(item)"
                  class="btn-filter-item-cross"
                  src="../../images/dashboard/cross.svg"
                  alt="#"
                />
                <span class="filter-item-txt" v-if="item === 0">Shipped</span>
                <span class="filter-item-txt" v-if="item === 1">Activated</span>
                <span class="filter-item-txt" v-if="item === 2">Submitted</span>
                <span class="filter-item-txt" v-if="item === 3">Received</span>
                <span class="filter-item-txt" v-if="item === 4">Hold</span>
                <span class="filter-item-txt" v-if="item === 5">Complete</span>
                <span class="filter-item-txt" v-if="item === 6">
                  Problematic
                </span>
                <span class="filter-item-txt" v-if="item === 7">Delivered</span>
                <span class="filter-item-txt" v-if="item === 8">Archived</span>
              </button>
            </div>
            <div
              class="input-wrap title_radio sub-filter"
              v-if="filters.includes(6)"
            >
              Sub Filter :
              <span class="radio-span">
                <input
                  type="radio"
                  name="sub_filter"
                  value="0"
                  v-model="subFilter"
                />All
              </span>
              <span class="radio-span">
                <input
                  type="radio"
                  name="sub_filter"
                  value="1"
                  v-model="subFilter"
                />Partial
              </span>
              <span class="radio-span">
                <input
                  type="radio"
                  name="sub_filter"
                  value="2"
                  v-model="subFilter"
                />Failed
              </span>
            </div>
            <div
              class="input-wrap title_radio sub-filter"
              v-if="filters.includes(6)"
            >
              <span class="radio-span">
                <input
                  type="checkbox"
                  name="overload_sub"
                  value="2"
                  v-model="missing"
                />Show Missing Outdoor Sample
              </span>
              <span class="radio-span">
                <input
                  type="checkbox"
                  name="overload_sub"
                  value="1"
                  v-model="overloadsub"
                />Show Overloaded
              </span>
            </div>
          </div>
        </transition>
        <transition name="router-anim">
          <div class="filter-items" v-if="step === 1">
            <button
              class="btn btn-test"
              @click="addAdmin"
              @click.stop="stopPropagation"
            >
              Add Admin
            </button>
          </div>
        </transition>
        <transition name="router-anim">
          <div class="filter-items" v-if="step === 2">
            <button
              class="btn btn-test"
              @click="addLabOperator"
              @click.stop="stopPropagation"
            >
              Add Lab Operator
            </button>
          </div>
        </transition>
        <transition name="router-anim">
          <div class="filter-items" v-if="step === 22">
            <button
              class="btn btn-test"
              @click="addMtcLab"
              @click.stop="stopPropagation"
            >
              Add MCT Lab User
            </button>
          </div>
        </transition>
        <transition name="router-anim">
          <div v-if="step === 3" style="width:100%">
            <div>
              <div class="filter-items" v-show="analytics_header.button">   <Search
                  :steps="step"
                  />
              </div>
              <div>
                <div class="filter-items" v-show="analytics_header.button">
                  <select v-if="analytics_header.type != null && isMapVisible " @change="onGroupChange" class="group-dropdown">
                    <option value="">No Grouping</option>
                    <option value="city">Group by City</option>
                    <option value="state">Group by State</option>
                    <option value="zip">Group by Zip</option>
                  </select>
                  <span
                    class="download-link"
                    target="_blank"
                    title="Download"
                    @click="AnalyticsInfoCsv"
                    v-if="analytics_header.button"
                  >
                    <span class="download">
                      <img src="../../images/dashboard/download.svg" alt="#" />
                    </span>
                  </span>
                  <!-- <div
                    class="filter-wrap"
                    v-click-outside="closeModel"
                  >
                    <button
                      class="btn btn-filter"
                      :class="{ open: showFilters }"
                      @click="showFilters = !showFilters"
                    >
                      Filter
                    </button>
                    <ul class="filter-list-wrap" v-show="showFilters">
                      <li class="filter-list-item hide">Status</li>
                      <li
                        class="filter-list-item"
                        @click="setFilter(0, 'shipped',1)"
                        :class="{ active: shipped }"
                      >
                        Shipped
                      </li>
                      <li
                        class="filter-list-item"
                        @click="setFilter(7, 'delivered', 1)"
                        :class="{ active: delivered }"
                      >
                        Delivered
                      </li>
                      <li
                        class="filter-list-item"
                        @click="setFilter(1, 'activated', 1)"
                        :class="{ active: activated }"
                      >
                        Activated
                      </li>
                      <li
                        class="filter-list-item"
                        @click="setFilter(2, 'awaiting', 1)"
                        :class="{ active: awaiting }"
                      >
                        Submitted
                      </li>
                      <li
                        class="filter-list-item"
                        @click="setFilter(3, 'received', 1)"
                        :class="{ active: received }"
                      >
                        Lab Received
                      </li>
                      <li
                        class="filter-list-item"
                        @click="setFilter(4, 'hold', 1)"
                        :class="{ active: hold }"
                      >
                        On Hold
                      </li>
                      <li
                        class="filter-list-item"
                        @click="setFilter(5, 'complete', 1)"
                        :class="{ active: complete }"
                      >
                        Analysis Complete
                      </li>
                      <li
                        class="filter-list-item"
                        @click="setFilter(6, 'problem', 1)"
                        :class="{ active: problem }"
                      >
                        Problematic Kits
                      </li>
                      <li
                        class="filter-list-item"
                        @click="setFilter(8, 'archive', 1)"
                        :class="{ active: archive }"
                      >
                        Archived Kits
                      </li>
                    </ul>
                  </div> -->
                  <!-- <div class="datepickerWrapDiv">
                    <Datepicker
                      placeholder="Date From"
                      v-model="analytics_date_from"
                      :format="formatDate"
                      :disabledDates="disabledDatesFrom"
                      :calendar-class="{ calendarWrap: true }"
                      :class="{ datepickerWrapAdmin: true }"
                      :input-class="{ datepickerInputAdmin: true }"
                    ></Datepicker>
                    <img
                      src="../../images/dashboard/calendar.png"
                      alt="#"
                      class="datepickerWrapDiv-img"
                    />
                    <button
                      class="datepickerWrapDiv-img-cross"
                      v-if="analytics_date_from !== null"
                      @click="analytics_date_from = null"
                    >
                      <CloseIcone></CloseIcone>
                    </button>
                  </div>
                  <div class="datepickerWrapDiv">
                    <Datepicker
                      placeholder="Date To"
                      v-model="analytics_date_to"
                      :format="formatDate"
                      :disabledDates="disabledDatesTo"
                      :calendar-class="{ calendarWrap: true }"
                      :class="{ datepickerWrapAdmin: true }"
                      :input-class="{ datepickerInputAdmin: true }"
                    ></Datepicker>
                    <img
                      src="../../images/dashboard/calendar.png"
                      alt="#"
                      class="datepickerWrapDiv-img"
                    />
                    
                    <button
                      class="datepickerWrapDiv-img-cross"
                      v-if="analytics_date_to !== null"
                      @click="analytics_date_to = null"
                    >
                      <CloseIcone></CloseIcone>
                    </button>
                  </div> -->
                  <city-state-filter></city-state-filter>
                  <button
                    v-if="analytics_header.button"
                    class="btn btn-test"
                    @click="showCount"
                  >
                    Back
                  </button>
                </div>
                <div class="btn-filter-item-wrap-research-5" v-show="analytics_header.button">
                  <button class="btn btn-filter-item text-left" v-for="item in filters">
                    <img
                      @click="resetStatusFilter(item)"
                      class="btn-filter-item-cross"
                      src="../../images/dashboard/cross.svg"
                      alt="#"
                    />
                    <span class="filter-item-txt" v-if="item === 0">Shipped</span>
                    <span class="filter-item-txt" v-if="item === 1">Activated</span>
                    <span class="filter-item-txt" v-if="item === 2">Submitted</span>
                    <span class="filter-item-txt" v-if="item === 3">Received</span>
                    <span class="filter-item-txt" v-if="item === 4">Hold</span>
                    <span class="filter-item-txt" v-if="item === 5">Complete</span>
                    <span class="filter-item-txt" v-if="item === 6">
                      Problematic
                    </span>
                    <span class="filter-item-txt" v-if="item === 7">Delivered</span>
                    <span class="filter-item-txt" v-if="item === 8">Archived</span>
                  </button>
                </div>
                <div
                  class="input-wrap title_radio sub-filter"
                  v-if="filters.includes(6)"
                  v-show="analytics_header.button"
                >
                  Sub Filter :
                  <span class="radio-span">
                    <input
                      type="radio"
                      name="sub_filter"
                      value="0"
                      v-model="subFilter"
                    />All
                  </span>
                  <span class="radio-span">
                    <input
                      type="radio"
                      name="sub_filter"
                      value="1"
                      v-model="subFilter"
                    />Partial
                  </span>
                  <span class="radio-span">
                    <input
                      type="radio"
                      name="sub_filter"
                      value="2"
                      v-model="subFilter"
                    />Failed
                  </span>
                </div>
                <div
                  class="input-wrap title_radio sub-filter"
                  v-if="filters.includes(6)"
                  v-show="analytics_header.button"
                >
                  <span class="radio-span">
                    <input
                      type="checkbox"
                      name="overload_sub"
                      value="2"
                      v-model="missing"
                    />Show Missing Outdoor Sample
                  </span>
                  <span class="radio-span">
                    <input
                      type="checkbox"
                      name="overload_sub"
                      value="1"
                      v-model="overloadsub"
                    />Show Overloaded
                  </span>
                </div>
              </div>
            </div>
          </div>
        </transition>
        <transition name="router-anim">
          <div v-if="step === 9">
            <button
              class="btn btn-test holiday"
              @click="addHolidaysModal"
              @click.stop="stopPropagation"
            >
              Add Holidays
            </button>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { mapActions,mapMutations  } from "vuex";
import { mapGetters } from "vuex";
import moment from "moment";
import ManagementList from "../dashboard/ManagementList";
import CloseIcone from "../../images/shared/cancel";
import Search from "./search/Search";
import SearchCustomer from "./search/SearchCustomer";
import InventorySearch from "./search/InventorySearch";
import CityStateFilter from './research/CityStateFilter.vue';

export default {
  name: "Filters",
  props: ["steps"],
  data() {
    return {
      title: [
        "Test Kit Management",
        "Admin Management",
        "Lab Operator Management",
        "Research",
        "Outlier Kits",
        "Reports",
        "QR Code Generator",
        "Kit URL Generator",
        "Customers",
        "Federal Holidays",
        "Woo Orders",
        "Import Kits from CSV",
        "",
        "Import Inactive CSV",
        "Inventory Management",
        "",
        "",
        "Amazon Inventory",
        "Sales",
        "Inventory"
      ],
      step: 0,
      api_url: process.env.VUE_APP_API_URL,
      file_url: process.env.VUE_APP_FILES_URL,
      show: false,
      filters: [],
      showFilters: false,
      shipped: false,
      activated: false,
      awaiting: false,
      received: false,
      archive: false,
      in_active:false,
      hold: false,
      complete: false,
      problem: false,
      delivered: false,
      showAddAdmin: false,
      free: false,
      all: false,
      paid: false,
      date_from: null,
      date_to: null,
      analytics_date_from: null,
      analytics_date_to: null,
      analytics_header: {},
      upload: "",
      filterSelect: 0,
      customerkit: 0,
      subFilter: 0,
      overloadsub: false,
      missing: false,
      params: 0,
      disabledDatesTo: {
        to: null
      },
      disabledDatesFrom: {
        to: null
      },
      payment_type: null,
      invkits:false,
      menu_label:'Test Kits',
      map: null
    };
  },
  computed: {
    ...mapGetters([
      "role",
      "getAnalyticsStatus",
      "customersCount",
      "getSubFilterStatus",
      "getOverloadSubStatus",
      "getPaymentFilter",
      "getCustomerkit",
      "getAnalyticsParams",
      "getAnalyticsFilter",
      "getStatus",
      "getDateToAnalytics",
      "getDateFromAnalytics",
      "getDateTo",
      "getDateFrom",
      "getStatusFilter",
      "getInvKit",
      "isMapVisible"
    ])
  },
  watch: {
    isMapVisible(val) {
      if (val) this.$nextTick(this.initMap);
    },
    getInvKit(obj){
      this.invkits = obj;
    },
    getStatus(value){
      // Convert the string into an array using the split method
      if(value == "" || value == null) {
        this.filters = [];
        this.shipped = false;
        this.activated = false;
        this.awaiting = false;
        this.received = false;
        this.hold = false;
        this.complete = false;
        this.problem = false;
        this.delivered = false;
        this.in_active = false;
        this.archive = false;
      }
    },
    getStatusFilter(item){
      if(item == null || item == '') {
        this.shipped = false;
        this.activated = false;
        this.awaiting = false;
        this.received = false;
        this.hold = false;
        this.complete = false;
        this.problem = false;
        this.delivered = false;
        this.filters = [];
        this.in_active = false;
        this.archive = false;
      }
      if (item.includes(',')) {
         const numbers = item.split(',').map(num => parseInt(num.trim())).filter(num => !isNaN(num));
         numbers.forEach(num => {
          if(!this.filters.includes(num)){
            this.filters.push(num);
          }
          switch (num) {
            case 0:
              this.shipped = true;
              break;
            case 1:
              this.activated = true;
              break;
            case 2:
              this.awaiting = true;
              break;
            case 3:
              this.received = true;
              break;
            case 4:
              this.hold = true;
              break;
            case 5:
              this.complete = true;
              break;
            case 6:
              this.problem = true;
              break;
            case 7:
              this.delivered = true;
              break;
            case 8:
              this.archive = true;
              break;
            case 12:
              this.in_active = true;
              break;
            default:
              break;
          }
        });
      }
    },
    getDateFrom(val) {
      if(val == null) {
        this.date_from = null;
      }
    },
    getDateFromAnalytics(val) {
      if(val == null) {
        this.analytics_date_from = null;
      }
    },
    getDateTo(val) {
      if(val == null) {
        this.date_to = null;
      }
    },
    getDateToAnalytics(val) {
      if(val == null) {
        this.analytics_date_to = null;
      }
    },
    customersCount(val) {
      this.filterSelect = val;
    },
    getCustomerkit(val) {
      this.customerkit = val;
    },
    getAnalyticsFilter(obj){
      this.setDateFromAnalytics(null);
      this.setDateToAnalytics(null);
    },
    date_from(newDate) {
      this.disabledDatesTo = {
        to: this.date_from
      };
      if (newDate) {
        newDate = moment(newDate)
          .utc()
          .format("YYYY-MM-DD 00:01:00");
      }
      this.setDateFrom(newDate);
      if (this.$store.getters.getComponentNum == "4") {
        this.sendSearchReqPending();
        this.getPendingInfoList("pending").then(res => {
          this.$emit("title", { show: false, value: this.$store.getters.getComponentNum });
        });
      } else if(this.$store.getters.getComponentNum == "32") {
        this.setWooOrdersData();
      } else {
        this.sendSearchReq();
      }
    },
    date_to(newDate) {
      this.disabledDatesFrom = {
        from: this.date_to
      };
      if (newDate) {
        newDate = moment(newDate)
          .utc()
          .format("YYYY-MM-DD 23:59:00");
      }
      this.setDateTo(newDate);
      if(this.$store.getters.getComponentNum == 3) {
        this.sendSearchReqPending();
        this.getPendingInfoList("pending").then(res => {
          this.$emit("title", { show: false, value: this.$store.getters.getComponentNum });
        });  
      } else if(this.$store.getters.getComponentNum == "32") {
        this.setWooOrdersData();
      }  else {
        this.sendSearchReq();
      }
    },
    analytics_date_from(newDate) {
      this.disabledDatesTo = {
        to: this.analytics_date_from
      };
      if (newDate) {
        newDate = moment(newDate)
          .utc()
          .format("YYYY-MM-DD 00:01:00");
      }
      this.setDateFromAnalytics(newDate);
      if(this.$store.getters.getComponentNum == 3) {
        this.setAdminPginationPage(null).then(() => {
           const data = this.$store.getters.getAnalyticsFilter;
           this.getAnalyticsInfoList(data);
        });
      }
    },
    analytics_date_to(newDate) {
      this.disabledDatesFrom = {
        from: this.analytics_date_to
      };
      if (newDate) {
        newDate = moment(newDate)
          .utc()
          .format("YYYY-MM-DD 23:59:00");
      }
      this.setDateToAnalytics(newDate);
      if(this.$store.getters.getComponentNum == 3) {
        this.setAdminPginationPage(null).then(() => {
             const data = this.getAnalyticsFilter;
             this.getAnalyticsInfoList(data);
        });
      }
    },
    getAnalyticsStatus(obj) {
      if (
        obj !== "undefined" ||
        (obj.type !== "undefined" && obj.item !== "undefined")
      ) {
        this.step = obj.status;
        this.show = obj.show;
        if (obj.item !== null) {
          obj.item = obj.item
            .toLowerCase()
            .replace(/\b[a-z]/g, function(letter) {
              return letter.toUpperCase();
            });
        }
        this.analytics_header = {
          type: obj.type,
          sub_type: obj.item,
          button: obj.show,
          count: obj.count,
          total: obj.total
        };
      }
    },
    getAnalyticsParams(obj) {
      this.params = obj;
    },
    getSubFilterStatus(obj) {
      this.subFilter = obj;
    },
    overloadsub(val) {
      if (val) {
        this.missing = false;
        this.setOverloadSub(1);
      } else {
        this.setOverloadSub(0);
      }
      if (this.$store.getters.getComponentNum == 3) {
        this.setAdminPginationPage(null).then(() => {
           const data = this.getAnalyticsFilter;
           this.getAnalyticsInfoList(data);
        });
      } else {
        this.sendSearchReq();
      }
    },
    missing(val) {
      if (val) {
        this.overloadsub = false;
        this.setOverloadSub(2);
      } else {
        this.setOverloadSub(0);
      }
      if (this.$store.getters.getComponentNum == 3) {
        this.setAdminPginationPage(null).then(() => {
           const data = this.getAnalyticsFilter;
           this.getAnalyticsInfoList(data);
        });
      } else {
        this.sendSearchReq();
      }
    },
    subFilter(val) {
      this.setSubFilter(val);
      if (this.$store.getters.getComponentNum == 3) {
        this.setAdminPginationPage(null).then(() => {
          const data = this.getAnalyticsFilter;
           this.getAnalyticsInfoList(data);
        });
      } else {
        this.sendSearchReq();
      }

    },
    steps(val) {
      var obj = {};
      var status = "";
      obj.value = val.steps;
      if (val.value == "shipped") {
        status = 0;
      }
      if (val.value == "activated") {
        status = 1;
      }
      if (val.value == "awaiting") {
        status = 2;
      }
      if (val.value == "received") {
        status = 3;
      }
      if (val.value == "hold") {
        status = 4;
      }
      if (val.value == "complete") {
        status = 5;
      }
      if (val.value == "problematic") {
        status = 6;
      }
      if (val.value == "delivered") {
        status = 7;
      }
      if (val.value == "in_active") {
        status = 12;
      }
      if (val.value == "archive") {
        status = 8;
      }
      this.setFilter(status, val.value, 0);
      if(val.steps == 4){
        obj.show= false;
        // this.getPendingInfoList("pending").then(res => {
        //   this.$emit("title", { show: false, value: val.steps });
        // });
      } else {
        obj.show = true;
      }
      this.setTitle(obj);
    },
    getPaymentFilter(val) {
      this.payment_type = val;
    }
  },
  methods: {
    ...mapActions([
      "setStatusFilter",
      "setProblemFilter",
      "setDateFrom",
      "setDateTo",
      "setDateToAnalytics",
      "setDateFromAnalytics",
      "sendSearchReq",
      "setAnalyticsHead",
      "getPendingInfoList",
      "sendSearchReqPending",
      "getContactCustomers",
      "setCustomerCount",
      "setAdminPginationPage",
      "getAnalyticsInfoCsv",
      "getCustomersCsv",
      "setSubFilter",
      "setOverloadSub",
      "setPaymentFilter",
      "changeDashboardValues",
      "overDues",
      "setCustomerkit",
      "getTestkitsCsv",
      "outlierKitsCsv",
      "getAnalyticsInfoList",
      "setWooOrdersData",
      "toggleMap"
    ]),
    ...mapMutations(["SET_GROUP_BY"]),
    onGroupChange(event) {
      const field = event.target.value;
      this.SET_GROUP_BY(field); // Commit to Vuex
    },
    initMap() {
      if (!this.map && window.L) {
        this.map = L.map('map').setView([20, 0], 2);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '© OpenStreetMap contributors'
        }).addTo(this.map);
      }
    },
    getClass() {
      if (this.show) {
        return "title"; // Add the class 'active'
      } else {
        return "title-selected"; // Add the class 'inactive'
      }
    },
    outlierkitCsvDownload() {
      this.outlierKitsCsv(null).then(async response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `OutlierKitsExport.csv`);
        link.click();
      });
    },
    async payment_type_change(val) {
      if (val) {
        await this.setPaymentFilter(val);
        this.changeDashboardValues();
        this.overDues();
      }
      if (this.steps.steps != "" || this.steps != "") {
        if (this.steps.steps == "0" || this.steps == "0") {
          this.sendSearchReq();
        } else if (this.steps.steps == "4" || this.steps == "4") {
          this.sendSearchReqPending();
        }
      }
    },
    convertDateUpload(date) {
      if (date !== null) return moment(date).format("MMMM Do, YYYY");
    },
    AnalyticsInfoCsv() {
      this.getAnalyticsInfoCsv(this.params).then(async response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `${this.params.type}_${this.params.item}.csv`
        );
        link.click();
      });
    },
    customersCsv() {
      this.getCustomersCsv(null).then(async response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `customerWithKits.csv`);
        link.click();
      });
    },
    handleChange(event) {
      this.setAdminPginationPage(null).then(() => {
        this.setCustomerCount(event.target.value).then(() => {
          this.getContactCustomers({ "`page`": 1 });
        });
      });
    },
    showoutlinerfilters(showfilter, value) {
      //this.steps.steps = 0;
      this.$emit("viewoutlinerfilters", {
        showfilter: showfilter,
        value: value
      });
    },
    closeModelList() {
      this.show = false;
    },
    closeModel() {
      if (this.showFilters) {
        this.showFilters = !this.showFilters;
      }
    },
    formatDate(date) {
      return moment(date).format("MMM DD, YYYY");
    },
    addAdmin() {
      this.$emit("showAddAdminModal", true);
    },
    addLabOperator() {
      this.$emit("showAddLabOperatorModal", true);
    },
    addMtcLab() {
      this.$emit("showAddMtcLabModal", true);
    },
    setFilter(item, model, param) {
      if (this.steps.steps == "0" && item == "" && model != "shipped") {
        return;
      }
      this[model] = !this[model];
      const found = this.filters.indexOf(item);
      if((this.steps.steps !='' && this.steps.steps == "4") || (this.steps.switchOrder && param == 0))
      {
        this.filters = [];
        this.filters.push(item);
        if(param == 0){
          this.shipped = false;
          this.activated = false;
          this.awaiting = false;
          this.received = false;
          this.hold = false;
          this.complete = false;
          this.problem = false;
          this.delivered = false;
          this.in_active = false;
          this.archive = false;
          switch (item) {
            case 0:
              this.shipped = true;
              break;
            case 1:
              this.activated = true;
              break;
            case 2:
              this.awaiting = true;
              break;
            case 3:
              this.received = true;
              break;
            case 4:
              this.hold = true;
              break;
            case 5:
              this.complete = true;
              break;
            case 6:
              this.problem = true;
              break;
            case 7:
              this.delivered = true;
              break;
            case 8:
              this.archive = true;
              break;
            case 12:
              this.in_active = true;
              break;
            default:
              break;
          }
        }
      } else if (found !== -1) {
        this.filters.splice(found, 1);
      } else if (typeof item !== "undefined") {
        this.filters.push(item);
      }

      ///console.log(this.filters);
      if (item == 6) {
        if (this.filters.includes(6)) {
          this.setProblemFilter(1);
        } else {
          this.setProblemFilter(null);
        }
      } else {
        this.setStatusFilter(this.filters);
      }
      if (this.steps.steps != "" && this.steps.steps == "4") {
        this.sendSearchReqPending();
      } else if (this.$store.getters.getComponentNum == 3) {
        this.setAdminPginationPage(null).then(() => {
           const data = this.getAnalyticsFilter;
           this.getAnalyticsInfoList(data);
        });
      } else {
        this.sendSearchReq();
      }
    },
    resetStatusFilter(item) {
      switch (item) {
        case 0:
          this.shipped = false;
          break;
        case 1:
          this.activated = false;
          break;
        case 2:
          this.awaiting = false;
          break;
        case 3:
          this.received = false;
          break;
        case 4:
          this.hold = false;
          break;
        case 5:
          this.complete = false;
          break;
        case 6:
          this.problem = false;
          break;
        case 7:
          this.delivered = false;
          break;
        case 8:
          this.archive = false;
          break;
        case 12:
          this.in_active = false;
          break;
        default:
          break;
      }

      const found = this.filters.indexOf(item);
      if (this.filters.length !== 0) {
        this.filters.splice(found, 1);
      } else {
        this.filters = null;
      }

      if (item == 6) {
        if (this.filters.includes(6)) {
          this.setProblemFilter(1);
        } else {
          this.setProblemFilter(null);
        }
        this.setStatusFilter(this.filters);
      } else {
        this.setStatusFilter(this.filters);
      }

      if (this.steps.steps != "" && this.steps.steps == "4") {
        this.sendSearchReqPending();
        var obj = {};
        obj.value = 4;
        obj.show = false;
        this.getPendingInfoList("pending").then(res => {
          this.$emit("title", { show: false, value: this.steps.steps });
        });
        this.setTitle(obj);
      } else if (this.$store.getters.getComponentNum == 3) {
        this.setAdminPginationPage(null).then(() => {
           const data = this.getAnalyticsFilter;
           this.getAnalyticsInfoList(data);
        });
      } else {
        this.sendSearchReq();
      }
    },
    addTestKitModal() {
      this.$emit("showTestKitModal", true);
    },
    addHolidaysModal() {
      this.$emit("showHolidaysModal", true);
    },
    setTitle(obj) {
      this.menu_label = obj.label;
      if((typeof this.steps.steps !== 'undefined' && this.steps.steps !== obj.value && obj.value == 4)) {
        this.$emit("outlinerkits", {steps : obj.value});
      }
      if (
        obj.value === 0 &&
        obj.value !== this.step &&
        !this.steps.switchOrder
      ) {
        this.filters = [];
        this.setStatusFilter(this.filters);
        this.shipped = false;
        this.activated = false;
        this.awaiting = false;
        this.received = false;
        this.hold = false;
        this.complete = false;
        this.problem = false;
        this.delivered = false;
      }

      this.show = obj.show;
      this.step = obj.value;
      this.analytics_header = { type: null, sub_type: null, button: false };
      this.$emit("showComponent", obj.value);
    },
    stopPropagation(event) {
      event.stopPropagation();
    },
    showCount() {
      this.analytics_header = { type: null, sub_type: null, button: false };
      this.setAnalyticsHead({
        status: 3,
        type: null,
        show: false,
        item: null,
        count: null
      });
    },
    showCustomer() {
      this.setCustomerkit(0);
    },
    testKitsCsv() {
      this.getTestkitsCsv(null).then(async response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `TestKitExport.csv`);
        link.click();
      });
    },
    showAddInv(){
      this.$emit("showAddInv", true);
    }
  },
  components: {
    ManagementList,
    Datepicker,
    CloseIcone,
    Search,
    SearchCustomer,
    InventorySearch,
    CityStateFilter
  },
  mounted() {
    this.payment_type = this.$store.getters.getPaymentFilter;
    this.params = this.$store.getters.getAnalyticsParams;
    this.invkits = this.$store.getters.getInvKit;
    this.$eventBus.$on("title", this.setTitle);
    this.$eventBus.$on("showoutlinerfilters", this.showoutlinerfilters);
  }
};
</script>

<style scoped>
.filter-all {
  top: 10px;
}
.filter-research-all {
  top: 25px;
}
.row {
  display: flex;
  justify-content: space-between;
  position: relative;
}
.title {
  color: #005eb8;
  font-size: 18px;
  font-family: TTNormsMedium, sans-serif;
  max-width: 412px;
  width: 100%;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin: 10px 0 0 0;
  cursor: pointer;
  border-radius: 5px;
  padding: 10px;
  border: 1px solid #e7ecef;
  border-radius: 5px;
  background-color: #ffffff;
}
.title-selected {
  color: #fff;
  font-size: 18px;
  font-family: TTNormsMedium, sans-serif;
  max-width: 412px;
  width: 100%;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin: 7px 0 0 0;
  cursor: pointer;
  background-color: #005eb8;
  border-radius: 5px;
  border: 1px #005eb8;
  padding: 10px;
}
.drop-down-menu {
  margin: 0px 0px 0px 5px;
}
.title-down {
  height: 18px;
  cursor: pointer;
  vertical-align: top;
}
.filter-items {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}
.filter-items-customer {
  padding-bottom: 10px;
  display: flex;
  width: 100%;
  justify-content: flex-end;
}
.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: 1px solid transparent;
  font-size: 12px;
  font-family: TTNormsLight, sans-serif;
  padding: 6px 15px 6px 15px;
  height: 30px;
  margin: 0 0 0 13px;
  cursor: pointer;
  border-radius: 5px;
}
.btn-filter-item {
  color: #fff;
  background-color: #ccc;
  cursor: default;
  margin: 0px 0 10px 13px;
}
.btn-more {
  width: 30px;
  height: 30px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 8px 7px;
}
.btn-row-item {
  display: flex;
  justify-content: space-between;
  max-width: 15px;
  width: 100%;
  margin: 2px 0;
}
.btn-point {
  background-color: #b3b3b3;
  width: 1px;
  height: 1px;
  border-radius: 100%;
}
.btn-row {
  background-color: #b3b3b3;
  width: 12px;
  height: 1px;
}
.btn-filter {
  background-color: #fff;
  color: #b3b3b3;
  border: 2px solid transparent;
  transition: all 0.5s linear;
}
.btn-filter.open {
  color: #005eb8;
  border: 2px solid #005eb8;
}
.btn-test {
  background-color: #005eb8;
  color: #fff;
  max-width: 128px;
  min-width: 100px;
}
.btn-test.custom {
  width: inherit;
}
.btn-filter-item-cross {
  max-width: 10px;
  height: auto;
  display: inline-block;
  margin: 0 10px 0 0;
  cursor: pointer;
}
.btn-filter-item-days {
  height: auto;
  display: inline-block;
  margin: 0 10px 0 0;
  cursor: pointer;
}
.filter-wrap {
  position: relative;
}

.filter-wrap-custom {
  display: inline-flex;
}
.filter-list-wrap {
  position: absolute;
  right: 0px;
  top: 35px;
  width: 160px;
  background-color: #fff;
  box-shadow: 0px 0px 5px 1px rgba(152, 164, 174, 0.4);
  z-index: 2;
}
.filter-list-wrap2 {
  max-height: 200px;
  overflow-y: scroll;
}
.filter-list-item {
  padding: 10px;
  font-size: 13px;
  color: #000;
  font-family: TTNormsLight, sans-serif;
  transition: all 0.5s linear;
  cursor: pointer;
}
.filter-list-item:hover {
  background-color: #e0e9f4;
}
.filter-list-item.hide {
  padding: 10px;
  font-size: 12px;
  color: #b3b3b3;
  font-family: TTNormsMedium, sans-serif;
  cursor: default;
}
.filter-list-item.hide:hover {
  background-color: #fff;
}
.filter-list-item.active {
  font-family: TTNormsMedium, sans-serif;
  color: #005eb8;
}
.datepickerWrapDiv {
  position: relative;
}
.datepickerWrapDiv-img {
  position: absolute;
  left: 18px;
  top: 8px;
  max-width: 14px;
}
.btn-filter-item-wrap {
  max-width: 550px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
}
.btn-filter-item-wrap-5 {
  max-width: 550px;
  width: 100%;
  display: flex;
  padding-top: 20px;
  align-items: center;
  flex-wrap: wrap;
}

.btn-filter-item-wrap-research-5 {
  max-width: 550px;
  width: 100%;
  display: flex;
  padding-top: 20px;
  align-items: center;
  flex-wrap: wrap;
  margin-left: auto; /* Move the container to the right */
}
.datepickerWrapDiv-img-cross {
  padding: 0;
  cursor: pointer;
  background-color: transparent;
  border: none;
  width: 11px;
  display: flex;
  align-self: center;
  justify-content: center;
  position: absolute;
  right: 10px;
  top: 10px;
  height: 11px;
}
.anaytic-heading{
  display: flex;
  justify-content: center;
  position: relative;
  top: 10px;
}

.fix-header {
  color: #005eb8;
  font-size: 20px;
  font-family: TTNormsMedium, sans-serif;
}
.filter-label {
  color: #005eb8;
  font-size: 18px;
  padding: 10px;
  font-family: TTNormsMedium, sans-serif;
}
.header-center {
  text-align: center;
}
.input-filter {
  padding: 5px 10px;
  color: #373737;
  width: 100%;
  font-size: 16px;
  text-align: center;
  outline: none;
  border-radius: 10px;
  border: 1px solid #cccccc;
  font-family: TTNormsLight, sans-serif;
  background: white;
}
option {
  font-family: TTNormsLight, sans-serif;
  background: white;
}
.download-link {
  display: flex;
  position: relative;
  justify-content: flex-start;
  align-items: center;
  margin: 0 20px 0 0;
  cursor: pointer;
  padding-left: 10px;
}
.download-link-btn {
  text-align: left;
  background-color: transparent;
  border: none;
  outline: none;
}
.download-link.span {
  max-width: 135px;
}
.download {
  width: 30px;
  height: 30px;
  background-color: #03409a;
  border-radius: 100%;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
}
.download img {
  max-width: 12px;
  height: auto;
  cursor: pointer;
}
.upload {
  position: absolute;
  bottom: -15px;
  color: #999999;
  font-size: 12px;
  width: 120%;
  left: 45px;
  font-family: TTNormsLight, sans-serif;
}
.title_radio {
  color: #005eb8;
  font-size: 15px;
  font-family: TTNormsMedium, sans-serif;
  width: 100%;
  justify-content: space-between;
  margin: 10px 0 0 0;
  cursor: pointer;
}
.sub-filter {
  text-align: right;
}
.pay_types {
  padding-right: 10px;
}
.checkbox-span {
  padding-right: 153px;
}
.menu-label {
  margin-top: 10px;
  color: #005eb8;
  font-size: 25px;
  font-family: TTNormsMedium, sans-serif;
}
.justify-content-center-search{
  display: flex;
  justify-content: center;
  position: relative;
  width: 50%;
}
.justify-content-center{
  display: flex;
  justify-content: center;
  position: relative;
}
.holiday {
  width: 120px;
}
</style>
<style scoped>
.switch {
  position: relative;
  display: flex;
  align-items: center;
  width: 50px;
  height: 23px;
}
.switch_label {
  position: relative;
  display: inline-block;
  width: 100px;
  height: 23px;
  color: #005eb8;
  font-size: 20px;
  font-family: TTNormsMedium, sans-serif;
}
.show_map {
  display: flex;
  padding-right: 25px;
  gap: 10px;
}



.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  border-radius: 24px;
  transition: 0.4s;
}

.slider:before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  border-radius: 50%;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #005eb8;;
}

input:checked + .slider:before {
  transform: translateX(26px);
}
.group-dropdown {
  padding: 5px 10px;
  color: #373737;
  text-align: center;
  outline: none;
  border-radius: 10px;
  border: 1px solid #cccccc;
  font-family: TTNormsLight, sans-serif;
  background: white;
  position: relative;
  right: 20px;
}
</style>

